@if (navigating()) {
  <mat-progress-bar class="navigation-progress" mode="indeterminate" />
}

<router-outlet></router-outlet>
